import React from 'react';
import { Link } from '@studio/legacy-components';
import PropTypes from 'prop-types';
import { ConditionText, Highlight } from './styled';

export const SegmentCondition = ({ negated, segment: segmentId, segments }) => {
  const segmentName = segments?.[segmentId]?.name;
  return (
    <ConditionText>
      user must<Highlight>{negated ? ' not' : ''}</Highlight> belong to{' '}
      <Highlight>
        <Link to={`/segments/${segmentId}/view`}>
          {segmentName || segmentId}
        </Link>
      </Highlight>
    </ConditionText>
  );
};

SegmentCondition.propTypes = {
  segment: PropTypes.string,
  negated: PropTypes.bool,
  segments: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    })
  ),
};

export default SegmentCondition;
